function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import classNames from 'classnames';
import React, { useMemo } from 'react';
export let ButtonVariant = /*#__PURE__*/function (ButtonVariant) {
  ButtonVariant["SOLID"] = "solid";
  ButtonVariant["OUTLINE"] = "outline";
  ButtonVariant["WHITE"] = "white";
  return ButtonVariant;
}({});
const Button = ({
  children,
  variant = ButtonVariant.SOLID,
  className,
  isLarge = false,
  ...props
}) => {
  const buttonClassNames = useMemo(() => classNames('flex', 'font-medium', 'items-center', 'justify-center', 'px-5', 'py-3.5', 'rounded-full', 'w-full', 'focus:outline-none', 'focus:ring-2', 'focus:ring-offset-2', 'focus:ring-kira-blue-500', 'disabled:bg-slate-300', 'disabled:text-slate-500', 'disabled:border-slate-200', 'disabled:shadow-none', `${isLarge ? 'text-xl' : 'text-lg'}`, {
    'drop-shadow-md text-slate-600 bg-white hover:bg-slate-10': variant === ButtonVariant.WHITE,
    'border border-kira-blue-300': variant !== ButtonVariant.WHITE,
    'text-kira-blue-300 hover:bg-slate-50': variant === ButtonVariant.OUTLINE,
    'text-white bg-kira-blue-300 hover:bg-kira-blue-500': variant === ButtonVariant.SOLID
  }, `${className ?? ''}`), [className, isLarge, variant]);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: buttonClassNames
  }, props), children);
};
export default Button;